export default "__VITE_ASSET__ufyywZAk__"